import type { StoryBlockProps } from "../../components/StoryBlock/StoryBlock";
import { useStoryBlockCore } from "./useStoryBlockCore";

export function useStoryBlock(props: Readonly<StoryBlockProps>) {
  return useStoryBlockCore(props);
}
